<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="alarmDevice"></gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-alarm-device-${tenantType}`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiGetAlarmDeviceList)
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiGetAlarmDeviceList)
						}
					"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import common from '../mixins/common'
import { apiGetDeviceTypeList } from '@/apis/account.api'
import { apiGetAlarmDeviceList } from '@/apis/alarm.api'

export default {
	name: 'alarmDevice',
	mixins: [common],
	data() {
		return {
			form: {
				deviceNo: null,
				designNo: null,
				deviceTypeClassify: null,
				deviceTypeIdList: null,
				userType: null,
			},
			searchOptions: {},
			cancelRequest: true,
			columns: [],
		}
	},
	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},

		getDeviceTypeFlag() {
			return this.tenantType === '1'
		},

		columnList() {
			return this.columns.filter(o => o.selected)
		},
		filterFields() {
			return [
				{
					prop: 'deviceNo',
					label: '设备通讯编号',
					type: 'input',
				},
				{
					prop: 'designNo',
					label: '外观编号',
					type: 'input',
				},
				{
					prop: 'userType',
					label: '客户类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.userType,
						needAllForSearch: true,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
					},
					hidden: this.tenantType !== '1',
				},
				{
					prop: 'deviceTypeClassify',
					label: '设备大类',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeClassify,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						filterable: true,
						needAllForSearch: true,
					},
					hidden: this.tenantType !== '0',
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.searchOptions.deviceTypeId,
						filterable: true,
						needAllForSearch: true,
						multiple: true,
					},
					hidden: this.tenantType !== '0',
				},
			].filter(item => !item.hidden)
		},
	},

	mounted() {
		this.$set(this.searchOptions, 'deviceTypeClassify', this.$store.getters.dataList.deviceTypeClassify)
		this.$set(this.searchOptions, 'userType', this.$store.getters.dataList.userType || [])
		if (this.$route.params?.deviceTypeClassify) {
			this.form.deviceTypeClassify = this.$route.params.deviceTypeClassify
		}
		this.getList(1, apiGetAlarmDeviceList)
	},

	methods: {
		apiGetAlarmDeviceList,
		handleFilterSearch() {
			this.getList(1, apiGetAlarmDeviceList)
		},
		handleFilterReset() {
			this.getList(1, apiGetAlarmDeviceList)
		},
		async queryDeviceTypeList() {
			apiGetDeviceTypeList({ tenantId: this.tenantId, deviceTypeClassify: this.form.deviceTypeClassify }).then(
				res => {
					let list = res.records || []
					let val = list.map(item => {
						return {
							value: item.deviceTypeId,
							label: item.deviceTypeName,
						}
					})
					this.$set(this.searchOptions, 'deviceTypeId', val)
				},
			)
		},
	},

	watch: {
		'form.deviceTypeClassify': {
			handler(newVal) {
				if (newVal) {
					this.form.deviceTypeIdList = []
				}
				this.queryDeviceTypeList()
			},
			immediate: true,
		},

		tenantType: {
			handler() {
				this.columns = [
					{
						key: 'deviceNo',
						name: '设备通讯编号',
					},
					{
						key: 'deviceTypeName',
						name: '设备类型',
						hidden: this.tenantType === '1',
					},
					{
						key: 'userTypeName',
						name: '客户类型',
						hidden: this.tenantType === '0',
					},
					{
						key: 'designNo',
						name: '外观编号',
					},
					{
						key: 'alarmCount',
						name: '告警数量',
					},
					{
						key: 'oprate',
						name: '操作',
						width: 200,
						render: (h, row) => {
							return this.$has('monitor:device:account:record:alarm')
								? h(
										'el-button',
										{
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.$router.push({
														name: 'deviceDetail',
														query: {
															deviceId: row.deviceId,
															deviceType: row.deviceTypeId,
														},
														params: {
															name: 'AlarmRecord',
														},
													})
												},
											},
										},
										'查看详情',
								  )
								: h('div', {}, '/')
						},
					},
				].filter(item => !item.hidden)
			},
			immediate: true,
		},
	},

	activated() {
		if (this.$route.params?.update) {
			this.form = this.$options.data().form
			this.form.deviceTypeClassify = this.$route.params.deviceTypeClassify
			this.getList(1, apiGetAlarmDeviceList)
		}
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
</style>
